import { Injectable } from '@angular/core';
import { ApiService } from './api';
import { OrganizationCheckRegister } from 'model/organizationCheckRegister';


@Injectable()
export class OrganizationCheckRegisterService {
    constructor(private api: ApiService) { }

    CreateOrganizationCheckRegisters(organizationChecks: OrganizationCheckRegister[]) : Promise<OrganizationCheckRegister[]> {
        return new Promise((resolve, reject) => {
            this.api
                .postWithAuth(this.api.endpoints.organizationCheck + '/createOrganizationCheckRegister', organizationChecks)
                .then(data => resolve(data as OrganizationCheckRegister[]), error => reject(error));
        });
    }

    updateCheckRegisters(organizationChecks: OrganizationCheckRegister[]) : Promise<OrganizationCheckRegister[]> {
        return new Promise((resolve, reject) => {
            this.api
                .postWithAuth(this.api.endpoints.organizationCheck + '/update', organizationChecks)
                .then(data => resolve(data as OrganizationCheckRegister[]), error => reject(error));
        });
    }

    deleteCheckRegister(CheckId: number) {
        return new Promise((resolve, reject) => {
            this.api
            .deleteWithAuth(this.api.endpoints.organizationCheck  + '/' + CheckId)
                .then(data => resolve(data), error => reject(error));
        });
    }
}



// WEBPACK FOOTER //
// ./src/services/organization-check-service.ts